import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import Link from 'react-router-dom/Link';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { MobileContext } from '../../../providers/MobileProvider'

const propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  item: PropTypes.shape({
    icon: PropTypes.element.isRequired,
    name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    routes: PropTypes.arrayOf(PropTypes.shape({
      path: PropTypes.string.isRequired,
    })),
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

const styles = () => ({
  item: {
    whiteSpace: 'nowrap',
  },
  icon: {
    minWidth: 40,
  },
});

class ListItemLink extends React.Component {
  static contextType = MobileContext;

  handleClick = () => {
    const { changeOpen } = this.context;
    const isMobile = window.matchMedia('(max-width: 559px)');
    if (isMobile.matches) {
      changeOpen();
    }
  };

  renderLink = React.forwardRef((itemProps, ref) => (
    <Link
      to={itemProps.href}
      {...itemProps}
      innerRef={ref}
      onClick={this.handleClick}
    />
  ));

  render() {
    const { classes, item, location } = this.props;
    const isCurrentPath = location.pathname
      .split('/')
      .slice(0, 3)
      .join('/')
      .includes(item.path, 0);
    const path = (item.routes && item.routes.length > 0)
      ? item.routes[0].path
      : item.path;
    return (
      <li>
        <ListItem
          selected={isCurrentPath}
          button
          classes={{ root: classes.item }}
          component={this.renderLink}
          href={path}
        >
          <ListItemIcon classes={{ root: classes.icon }}>
            {item.icon}
          </ListItemIcon>
          <ListItemText primary={item.name} />
        </ListItem>
      </li>
    );
  }
}

ListItemLink.propTypes = propTypes;

export default withRouter(withStyles(styles)(ListItemLink));
